import { useCallback, useState } from 'react';

const PREFIX = 'pelvi:onboarding-seen:';

export function onboardingKey(personId: string, orgId: string) {
  return `${PREFIX}${personId}:${orgId}`;
}

function readSeen(key: string | null): boolean {
  if (!key) return true; // sem identificação não abrimos automaticamente
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return true;
  }
}

/**
 * Controla o dialog de boas-vindas: abre sozinho uma vez por pessoa+clínica
 * (persistido em localStorage) e pode ser reaberto manualmente via `show()`.
 */
export function useOnboarding(personId?: string, orgId?: string) {
  const key = personId && orgId ? onboardingKey(personId, orgId) : null;
  const [open, setOpen] = useState(() => !readSeen(key));

  const markSeen = useCallback(() => {
    if (!key) return;
    try {
      localStorage.setItem(key, '1');
    } catch {
      /* localStorage indisponível: o dialog pode reaparecer, sem prejuízo */
    }
  }, [key]);

  const close = useCallback(() => {
    markSeen();
    setOpen(false);
  }, [markSeen]);

  const show = useCallback(() => setOpen(true), []);

  return { open, show, close };
}
